import { gql } from '@common/hooks';
import { HistoryInfoFragment } from '@common/graphql';

export const PerformStaffingRequestAction = gql`
  fragment StaffingRequestActionStateInfo on StaffingRequest {
    id
    stateChangedAt
    openStaffingRequestPositionsCount
    latestApplicationUpdatedAt

    canPending {
      value
    }

    canOpenUp {
      value
    }

    canFill {
      value
    }

    canHold {
      value
    }

    canCancel {
      value
    }
  }

  mutation PerformStaffingRequestAction(
    $staffingRequestId: ID!
    $input: PerformStaffingRequestActionInput!
  ) {
    performStaffingRequestAction(
      staffingRequestId: $staffingRequestId
      input: $input
    ) {
      staffingRequest {
        id
        state
        canUpdatePositionCount {
          value
        }
        history {
          ...HistoryInfoFragment
        }
        ...StaffingRequestActionStateInfo
      }
    }
  }
  ${HistoryInfoFragment}
`;
